// Product slider: native sideways scroll with snap, plus dots and arrows
// that move one screenful at a time. Works left-to-right and right-to-left
// (in RTL scrollLeft runs from 0 down to negative numbers).
(function () {
  var SVG_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m15 18-6-6 6-6"/></svg>';
  var SVG_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m9 18 6-6-6-6"/></svg>';

  function setup(root) {
    if (root.__ps) return;
    root.__ps = true;

    var track = root.querySelector('[data-pslider-track]');
    var nav = root.querySelector('[data-pslider-nav]');
    var dotsWrap = root.querySelector('[data-pslider-dots]');
    var prev = root.querySelector('[data-pslider-prev]');
    var next = root.querySelector('[data-pslider-next]');
    if (!track || !nav || !dotsWrap || !prev || !next) return;
    prev.innerHTML = SVG_PREV;
    next.innerHTML = SVG_NEXT;

    var ar = document.documentElement.lang === 'ar';
    var rtl = getComputedStyle(track).direction === 'rtl';
    var geo = { pitch: 1, visible: 1, cols: 1, pages: 1 };
    var dots = [];
    var ticking = false;

    function cards() {
      return [].slice.call(track.children).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    function measure() {
      var list = cards();
      if (!list.length) { geo.pages = 1; return; }
      var first = list[0];
      var x0 = first.offsetLeft;
      var rows = list.length;
      var pitch = 0;
      for (var i = 1; i < list.length; i++) {
        if (Math.abs(list[i].offsetLeft - x0) > 2) {
          rows = i;
          pitch = Math.abs(list[i].offsetLeft - x0);
          break;
        }
      }
      var cs = getComputedStyle(track);
      var inner = track.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var gap = parseFloat(cs.columnGap) || 0;
      if (!pitch) pitch = first.offsetWidth + gap;
      geo.pitch = pitch;
      geo.visible = Math.max(1, Math.round((inner + gap) / pitch));
      geo.cols = Math.ceil(list.length / Math.max(1, rows));
      geo.pages = Math.max(1, Math.ceil(geo.cols / geo.visible));
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function position() {
      return Math.abs(track.scrollLeft);
    }

    function currentPage() {
      if (geo.pages <= 1) return 0;
      if (position() >= maxScroll() - 4) return geo.pages - 1;
      var col = Math.round(position() / geo.pitch);
      return Math.min(geo.pages - 1, Math.round(col / geo.visible));
    }

    function goTo(page) {
      page = Math.max(0, Math.min(geo.pages - 1, page));
      var target = Math.min(maxScroll(), page * geo.visible * geo.pitch);
      track.scrollTo({ left: rtl ? -target : target, behavior: 'smooth' });
    }

    function buildDots() {
      dotsWrap.innerHTML = '';
      dots = [];
      for (var i = 0; i < geo.pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pslider__dot';
        b.setAttribute('aria-label', (ar ? 'صفحة ' : 'Page ') + (i + 1) + ' / ' + geo.pages);
        b.setAttribute('data-page', i);
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    }

    function paint() {
      var page = currentPage();
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === page ? 'true' : 'false'); });
      prev.disabled = position() <= 4;
      next.disabled = position() >= maxScroll() - 4;
    }

    function refresh() {
      if (root.classList.contains('is-grid')) { nav.hidden = true; return; }
      measure();
      nav.hidden = geo.pages <= 1;
      if (dots.length !== geo.pages) buildDots();
      paint();
    }

    dotsWrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-page]');
      if (b) goTo(parseInt(b.getAttribute('data-page'), 10));
    });
    prev.addEventListener('click', function () { goTo(currentPage() - 1); });
    next.addEventListener('click', function () { goTo(currentPage() + 1); });

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; paint(); });
    }, { passive: true });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refresh, 150);
    });

    // Cards change height once their images load; measure again then.
    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', refresh, { once: true });
    });

    root.addEventListener('pslider:grid', function () {
      track.scrollLeft = 0;
      refresh();
    });

    refresh();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pslider]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
